import { css } from 'styled-components';

import type { ButtonStyleProps } from '/shared/components/widgets/button/buttonTypes';

export default function flexStyle({ $primary, $secondary }: ButtonStyleProps) {
  return css`
    > * {
      display: flex;
      align-items: center;
      justify-content: space-between;
      ${
        ($primary || $secondary) &&
        css`
        justify-content: center;
      `
      }
      flex: 1;
      height: auto;

      > * {
        padding: 0 0.5rem;

        &:first-child {
          padding-left: 0;
        }

        &:last-child {
          padding-right: 0;
        }
      }
    }
  `;
}
